"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCreateProjectDropMutation = void 0;
const useStore_1 = require("root/src/client/logic/helpers/useStore");
const react_query_1 = require("@tanstack/react-query");
const createProjectDrop_1 = __importDefault(require("root/src/client/logic/project/thunks/createProjectDrop"));
function useCreateProjectDropMutation() {
    const dispatch = (0, useStore_1.useAppDispatch)();
    return (0, react_query_1.useMutation)({
        mutationKey: ['createProjectDrop'],
        mutationFn: (params) => __awaiter(this, void 0, void 0, function* () {
            // @ts-ignore
            const response = yield dispatch((0, createProjectDrop_1.default)(params));
            if (response.error) {
                throw response.error;
            }
            return response.body;
        }),
    });
}
exports.useCreateProjectDropMutation = useCreateProjectDropMutation;
